import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAddCateringOrderInputModel } from '../shared/interfaces/add-catering-order-input.interface';
import { ICateringLogOutputModelServerResponse } from '../shared/interfaces/catering-log-output.interface';
import { ICateringOrderInputModel } from '../shared/interfaces/catering-order-input.interface';
import { ICateringOrderOutputModelServerResponse } from '../shared/interfaces/catering-order-output.interface';
import { IBooleanServerResponse } from '../shared/interfaces/server-response.interface';
import { ICateringServiceProviderListResponse, ICateringStatusListResponse } from './catering.model';

@Injectable({
  providedIn: 'root'
})
export class CateringService {

  constructor(private _httpClient: HttpClient) { }

  getCateringServiceProviderList(): Observable<ICateringServiceProviderListResponse> {
    const url = `${environment.apiHost}/Catering/GetCateringServiceProviderList`;
    return this._httpClient.get<ICateringServiceProviderListResponse>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCateringStatusList(): Observable<ICateringStatusListResponse> {
    const url = `${environment.apiHost}/Catering/GetCateringStatusList`;
    return this._httpClient.get<ICateringStatusListResponse>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  addCateringOrder(cateringOrderModel: IAddCateringOrderInputModel): Observable<ICateringOrderOutputModelServerResponse> {
    const url = `${environment.apiHost}/Catering/AddCateringOrder`;
    return this._httpClient.post<ICateringOrderOutputModelServerResponse>(url, cateringOrderModel)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCateringOrderListByLegIdList(serviceRequestStepIdList: string[]): Observable<ICateringOrderOutputModelServerResponse> {
    const url = `${environment.apiHost}/Catering/GetCateringOrderList`;
    return this._httpClient.post<ICateringOrderOutputModelServerResponse>(url, serviceRequestStepIdList)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  editCateringOrder(cateringOrderList: ICateringOrderInputModel[]): Observable<ICateringOrderOutputModelServerResponse> {
    const url = `${environment.apiHost}/Catering/EditCateringOrder`;
    return this._httpClient.put<ICateringOrderOutputModelServerResponse>(url, cateringOrderList)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  updateCateringOrderStatus(cateringOrder: ICateringOrderInputModel): Observable<IBooleanServerResponse> {
    const url = `${environment.apiHost}/Catering/UpdateCateringStatus`;
    return this._httpClient.put<IBooleanServerResponse>(url, cateringOrder)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCateringLogsByServiceRequestId(serviceRequestId: string): Observable<ICateringLogOutputModelServerResponse> {
    const url = `${environment.apiHost}/Catering/GetCateringLogs/${serviceRequestId}`;
    return this._httpClient.get<ICateringLogOutputModelServerResponse>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
